"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerifiablePresentation = exports.reviveDateFromTimeStampAttribute = exports.replaceDateWithTimeStampAttribute = void 0;
const json_bigint_1 = __importDefault(require("json-bigint"));
/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types */
/**
 * Replacer to ensure dates are stringified to the timestamp attribute format.
 */
function replaceDateWithTimeStampAttribute(k, value) {
    const rawValue = this[k];
    if (rawValue instanceof Date) {
        return { type: 'date-time', timestamp: rawValue.toISOString() };
    }
    return value;
}
exports.replaceDateWithTimeStampAttribute = replaceDateWithTimeStampAttribute;
/**
 * Reviver to ensure dates are parsed from the timestamp attribute format.
 */
function reviveDateFromTimeStampAttribute(_key, value) {
    if (value.type === 'date-time' &&
        typeof value.timestamp === 'string' &&
        Object.keys(value).length === 2) {
        return new Date(Date.parse(value.timestamp));
    }
    return value;
}
exports.reviveDateFromTimeStampAttribute = reviveDateFromTimeStampAttribute;
/* eslint-enable @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types */
class VerifiablePresentation {
    constructor(presentationContext, proof, type, verifiableCredential) {
        this.presentationContext = presentationContext;
        this.proof = proof;
        this.type = type;
        this.verifiableCredential = verifiableCredential;
    }
    toString() {
        return (0, json_bigint_1.default)({
            alwaysParseAsBig: true,
            useNativeBigInt: true,
        }).stringify(this);
    }
    static fromString(json) {
        // We allow all numbers to be parsed as bigints to avoid lossy conversion of attribute values. The structure does not contain any other numbers.
        const parsed = (0, json_bigint_1.default)({
            alwaysParseAsBig: true,
            useNativeBigInt: true,
        }).parse(json);
        return new VerifiablePresentation(parsed.presentationContext, parsed.proof, parsed.type, parsed.verifiableCredential);
    }
}
exports.VerifiablePresentation = VerifiablePresentation;
